import { ComponentStepProps } from "#/ui/Modal"

import { ReviewIncreasedAmount } from "./increase-amount"
import { useManageStakeFlowContext } from "./ManageStakeFlowContext"

export default function ReviewAndSignStep(props: ComponentStepProps) {
  const { manageType } = useManageStakeFlowContext()

  if (manageType === "increase-amount")
    return <ReviewIncreasedAmount {...props} />

  return null
}
